import clsx from 'clsx';
import React, { Activity, MouseEventHandler } from 'react';
import { IButtonStyle } from '../../interface/interface';
import { getInlineStyles } from '../../utils/styles';
import { Visual } from '../Image/Visual';
import styles from './styles/buttonFlat.module.css';

type TButtonFlatProps = {
    label?: string;
    iconName?: string;
    onClick?: MouseEventHandler;
} & IButtonStyle;

export const ButtonFlat = (props: TButtonFlatProps) => {
    return (
        <Activity mode={props.isHide ? 'hidden' : 'visible'}>
            <button
                className={clsx(styles.floatButton, props.isDisabled && styles.floatButtonDisabled)}
                onClick={props.onClick}
                style={getInlineStyles({
                    margin: {
                        top: props.marginTop,
                        bottom: props.marginBottom,
                        left: props.marginLeft,
                        right: props.marginRight,
                    },
                })}
            >
                <Visual
                    isWidget={false}
                    iconVariant={'circle'}
                    iconHierarchy={'primary'}
                    iconName={props.iconName}
                    isDisabled={props.isDisabled}
                    margin={{ bottom: 8 }}
                />
                {props.label}
            </button>
        </Activity>
    );
};
